import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

/**
 * Returns a `boolean` indicating the state of successful login.
 */
export const useHasLoggedIn = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => {
    const { matches, history } = state;

    const wasFetchingCustomerData = history?.matches('fetching.customer') === true;
    const hasLoggedIn = matches('session.loggedIn');

    return wasFetchingCustomerData && hasLoggedIn;
  });
};
